import React, { useEffect, useMemo, useState } from 'react';
import { FaRegUser } from 'react-icons/fa';
import { FcOk } from 'react-icons/fc';

import { Accordion, AccordionDetails, AccordionSummary, Box, Grid, useTheme } from '@material-ui/core';
import { Warning } from '@material-ui/icons';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Backdrop, Typography } from '@room-match/shared-ui-components';
import { FormikProps, useFormik } from 'formik';
import Complete from 'pages/CheckIn/CheckInForm/Complete/Complete';
import Information from 'pages/PastSelfTapes/PastSelfTape/Information';
import { useQueryClient } from 'react-query';
import { useHistory } from 'react-router-dom';
import GuardianshipModal from 'shared/components/GuardianshipModal/GuardianshipModal';
import Messaging from 'shared/components/Messaging/Messaging';
import SizeCard from 'shared/components/SizeCard/SizeCard';
import { COLORS } from 'shared/constants/COLORS';
import { ROUTES } from 'shared/constants/ROUTES';
import { CustomTypography } from 'shared/elements/CustomTypography';
import { SelftapesSteps } from 'shared/enums/SelftapesSteps';
import useWindowDimensions from 'shared/hooks/useWindowDimenstion';
import { IAuditionAttributes } from 'shared/interfaces/IAudition';
import { IAuditionScheduleCreatePayload, ISelfTapesScheduleResponse } from 'shared/interfaces/IAuditionSchedule';
import { IProject } from 'shared/interfaces/IProject';
import { useAppSelector } from 'shared/redux/store';
import { auditionScheduleService } from 'shared/services/auditionScheduleService';
import { projectService } from 'shared/services/projectService';
import { ls } from 'shared/utils/ls';
import * as yup from 'yup';
import { captureMessage } from '../../../lib/sentry';
import { RepresentationAndRole } from '../RepresentationAndRole';
import { SelfTapesTerms } from '../Terms';
import { CompanyInformation } from './CompanyInformation';
import { HeaderCont, useStyles } from './Form.styles';
import { RequiredQuestions } from './RequiredQuestions';
import { RoleInformation } from './RoleInformation';
import SelfTapesUpload from './SelfTapesUpload/SelfTapesUpload';
import WrongIcon from './wrongIcon';
const { ERROR_ICON, DARK_ICON, LIGHT_GREEN_ICON, WHITE_BACKGROUND, DARK_GREEN_TEXT } = COLORS;

type Props = {
  setActiveStep(step: number): void;
  activeStep: number;
  // auditionData?: IAuditionAttributes;
  projectData?: IProject;
  auditionSchedData?: ISelfTapesScheduleResponse['data'];
};
const { createAuditionScheduleSelfTapes, getSpecificAuditionSchedule } = auditionScheduleService();
const { getProjectQuestions } = projectService();
const Form: React.FC<Props> = ({ setActiveStep, activeStep, projectData, auditionSchedData }) => {
  const theme = useTheme();
  const { getLS, removeLS } = ls();
  const history = useHistory();
  const lsAuditionData: ISelfTapesScheduleResponse['data'] | undefined =
    auditionSchedData || JSON.parse(getLS('auditionData') || '{}');
  const ls_role_id = getLS('roleId');
  const { mutateAsync, isLoading: createIsLoading } = createAuditionScheduleSelfTapes();
  const self_tapes_revision_provided = auditionSchedData?.attributes.self_tapes_requirement_revision;

  const classes = useStyles();
  const { width } = useWindowDimensions();
  const [submitted, setsubmitted] = useState(false);
  const [auditionData, setauditionData] = useState<IAuditionAttributes | undefined>(
    lsAuditionData ? lsAuditionData?.attributes?.audition?.data?.attributes : undefined,
  );
  const [noReq, setnoReq] = useState(false);
  const [auditionSchedId, setauditionSchedId] = useState(lsAuditionData?.id);
  const { data: questions } = getProjectQuestions(projectData?.id || '', auditionData?.casting_role.data.id || '');

  const queryClient = useQueryClient();
  const [submitting, setsubmitting] = useState(false);
  const [expanded, setexpanded] = useState(true);
  const [showSelectProfile, setShowSelectProfile] = useState(false);
  const [hideSelectProfile, setHideSelectProfile] = useState(false);
  const { app: appState } = useAppSelector((state) => state);
  const { members } = appState.guardian;

  const isNonRepre = useMemo(() => {
    return (
      auditionSchedData?.attributes.audition.data.attributes.profile.data.attributes.representation_type ===
      'Non-Represented'
    );
  }, [auditionSchedData]);

  const checkedRoleId = projectData?.attributes?.self_tapes_roles?.data.find((r) => r.id === ls_role_id);

  const initialValues: IAuditionScheduleCreatePayload = {
    role_id: checkedRoleId ? ls_role_id : '',
    profile_id: '',
  };

  const ndaRequired = projectData?.attributes.required_signed_nda;

  const handleNext = (step: SelftapesSteps) => {
    history.push(`${step}`);
  };

  useEffect(() => {
    if (auditionData) {
      removeLS('auditionData');
    }
  }, [auditionData]);

  const handleSubmit = async (values: IAuditionScheduleCreatePayload, helper: any) => {
    setsubmitting(true);
    setsubmitted(false);
    await mutateAsync(
      { payload: values },
      {
        onSuccess: (data) => {
          queryClient.invalidateQueries(['auditionSchedule'], {
            refetchInactive: true,
          });
          if (
            data.data.attributes.audition.data.attributes.casting_role.data.attributes.self_tapes_requirements === null
          ) {
            return setnoReq(true);
          }
          setauditionSchedId(data.data.id);
          setauditionData(data.data.attributes.audition.data.attributes);
          // setActiveStep(activeStep + 1);
          history.push(`${ROUTES.TALENT.SELFTAPES}/${projectData?.id}/${data.data.id}/${SelftapesSteps.SIZE_CARD}`);
          setsubmitting(false);
          // captureMessage({
          //   message: 'user self-tapes representation and role',
          //   data: values,
          // });
        },
        onError: (data: any) => {
          if (data.response.data.errors.base[0] === 'You have already submitted to this project') {
            // setActiveStep(6);
            helper.resetForm();
            setsubmitted(true);
            captureMessage({
              message: 'user self-tapes representation and role',
              data: {
                values,
                status: 'already submitted to this project',
              },
            });
          } else {
            captureMessage({
              message: 'user self-tapes representation and role',
              data: values,
              level: 'error',
            });
          }
        },
      },
    );
  };

  const createResumeValidationSchema: yup.SchemaOf<IAuditionScheduleCreatePayload> = yup.object().shape({
    // representation_type: yup.mixed<RepresentationType>().oneOf(Object.values(RepresentationType)).required(),
    role_id: yup.string().required(),
    profile_id: yup.string().required(),
  });

  const form: FormikProps<IAuditionScheduleCreatePayload> = useFormik({
    initialValues,
    validationSchema: createResumeValidationSchema,
    onSubmit: (values, helper) => {
      handleSubmit(values, helper);
    },
  });

  useEffect(() => {
    if (form.values.profile_id && form.values.role_id && submitted) {
      setsubmitted(false);
    }
  }, [form]);

  useEffect(() => {
    if (members.length && !getLS('prev_url')) setShowSelectProfile(true);
  }, []);

  const handleCloseModal = () => {
    setShowSelectProfile(false);
    setHideSelectProfile(true);
  };

  const renderHeader = () => (
    <HeaderCont>
      <CustomTypography className={classes.heading} fontSize={18}>
        {projectData?.attributes?.company_name || ''} - {projectData?.attributes?.name || ''}
      </CustomTypography>
      <RoleInformation
        time={auditionData?.casting_role.data.attributes.self_tapes_requirements?.time}
        dueDate={auditionData?.casting_role.data.attributes.self_tapes_requirements?.date}
        timezone={auditionData?.casting_role.data.attributes.self_tapes_requirements?.timezone}
        projectData={projectData}
      />
    </HeaderCont>
  );

  if (createIsLoading) return <Backdrop isLoading={true} />;
  if (!auditionData?.id) {
    return (
      <>
        <GuardianshipModal
          showSelectProfile={showSelectProfile}
          close={handleCloseModal}
          pageName="like to submit Self-Tape"
        />
        <RepresentationAndRole
          disableRole={Boolean(checkedRoleId)}
          createIsLoading={createIsLoading}
          form={form}
          submitted={submitted}
          noReq={noReq}
          projectData={projectData}
          confirm={() => handleSubmit(form.values, form.getFieldHelpers)}
        />
      </>
    );
  }

  const renderMessaging = () => {
    return (
      <Messaging
        messageKey={isNonRepre ? 'casting_talent_messages' : 'agent_talent_messages'}
        showEmpty
        type="new-audition-requests"
        id={auditionSchedData?.id || ''}
        projectId={projectData?.id as string}
      />
    );
  };

  return (
    <Grid className={classes.root}>
      {activeStep < 5 && (
        <>
          {width > 960 || (activeStep === 3 && width < 960) ? (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                maxWidth: 550,
                minWidth: 550,
                gap: '2em',
              }}
            >
              <Grid item className={`${classes.container} ${classes.left}`}>
                {renderHeader()}
                <CompanyInformation
                  generalNotes={projectData?.attributes?.self_tapes_note || ''}
                  auditionData={auditionData}
                  union={projectData?.attributes.union}
                />
              </Grid>
              {renderMessaging()}
            </div>
          ) : (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <Accordion
                expanded={expanded}
                onChange={() => setexpanded(!expanded)}
                style={{
                  border:
                    theme.palette.type === 'dark'
                      ? `1px solid ${COLORS.DARK_BORDER}`
                      : `1px solid ${COLORS.LIGHT_BORDER}`,
                  borderRadius: 8,
                  background: theme.palette.type === 'dark' ? COLORS.DARK_BACKGROUND : COLORS.WHITE,
                }}
              >
                <AccordionSummary aria-controls="panel2d-content" expandIcon={<ExpandMoreIcon />}>
                  {renderHeader()}
                </AccordionSummary>
                <AccordionDetails>
                  <CompanyInformation
                    generalNotes={projectData?.attributes?.self_tapes_note || ''}
                    auditionData={auditionData}
                    union={projectData?.attributes.union}
                  />
                </AccordionDetails>
              </Accordion>
            </div>
          )}
        </>
      )}
      <GuardianshipModal
        showSelectProfile={showSelectProfile}
        close={handleCloseModal}
        pageName="like to submit Self-Tape"
      />
      {auditionData ? (
        <Grid item className={classes.rightContainer}>
          <Information auditionSchedId={auditionSchedId} />
          {activeStep === 4 ? (
            <div className={`${classes.containerWarn}`}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                <div style={{ display: 'flex', gap: 5 }}>
                  <Warning style={{ color: ERROR_ICON }} />
                  <Typography fontSize={17} fontWeight={700}>
                    Attention
                  </Typography>
                </div>
                <Typography>
                  All media should always be in{' '}
                  <span style={{ fontWeight: 700, textDecoration: 'underline' }}>landscape</span> format only ! (except
                  for Full Body Pic)
                </Typography>
                <Typography>
                  Please upload a <span style={{ fontWeight: 700 }}>current horizontal (landscape) selfie </span>
                  that has the same background as your audition video(s).{' '}
                </Typography>
                <Typography>
                  <span style={{ fontWeight: 700 }}>Do not upload a professional headshot image. </span>
                  These can be added to your Casting App profile instead.
                </Typography>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div
                  style={{
                    background: WHITE_BACKGROUND,
                    minWidth: 100,
                    height: 140,
                    borderRadius: 5,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    position: 'relative',
                  }}
                >
                  <WrongIcon style={{ position: 'absolute', top: -18, height: 35, width: 35 }} />
                  <FaRegUser color={DARK_ICON} size={45} />
                </div>
                <span
                  style={{
                    bottom: -25,
                    color: ERROR_ICON,
                    fontWeight: 500,
                    fontSize: 17,
                    textAlign: 'center',
                  }}
                >
                  Portrait
                </span>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div
                  style={{
                    background: WHITE_BACKGROUND,
                    minWidth: 186,
                    height: 140,
                    borderRadius: 5,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    position: 'relative',
                  }}
                >
                  <FcOk color={LIGHT_GREEN_ICON} size={40} style={{ position: 'absolute', top: -20 }} />
                  <FaRegUser color={DARK_ICON} size={45} />
                </div>
                <span
                  style={{ bottom: -25, color: DARK_GREEN_TEXT, fontWeight: 500, fontSize: 17, textAlign: 'center' }}
                >
                  Landscape
                </span>
              </div>
            </div>
          ) : (
            <React.Fragment />
          )}
          {activeStep === 5 ? (
            <Grid item className={`${classes.container}`}>
              <Complete info={auditionData?.profile.data} selfTapes />
            </Grid>
          ) : (
            <Grid item className={`${classes.container}`}>
              {activeStep === 2 ? (
                <Grid item className={classes.heading}>
                  <CustomTypography fontSize={18}>Please answer questions below</CustomTypography>
                </Grid>
              ) : (
                activeStep === 4 && (
                  <Grid item className={classes.heading}>
                    <CustomTypography fontSize={18}>
                      Please complete the self-tapes requirements below{' '}
                    </CustomTypography>
                  </Grid>
                )
              )}
              <Grid
                item
                style={{
                  position: 'relative',
                  opacity: !auditionData ? 0.5 : 1,
                }}
              >
                {!auditionData && (
                  <Box style={{ width: '100%', height: '100%', position: 'absolute', zIndex: 99 }}></Box>
                )}
                {activeStep === 1 ? (
                  <>
                    <SizeCard
                      checkinSelfTapes
                      onSave={() => {
                        // captureMessage({
                        //   message: 'user self-tapes size card',
                        //   data: questions,
                        // });
                        if (!questions?.data.length) {
                          if (!ndaRequired) return history.push(`${SelftapesSteps.UPLOADS}`);
                          history.push(`${SelftapesSteps.TERMS}`);
                        } else {
                          history.push(`${SelftapesSteps.QUESTIONS}`);
                        }
                      }}
                    />
                    {submitted && (
                      <Typography color="errorText" style={{ marginTop: 5 }}>
                        Self-tape already submitted
                      </Typography>
                    )}
                    {noReq && (
                      <Typography color="errorText" style={{ marginTop: 5 }}>
                        Self-tape has no requirements
                      </Typography>
                    )}
                  </>
                ) : activeStep === 2 ? (
                  <RequiredQuestions
                    auditionID={auditionSchedId}
                    handleNext={() => {
                      // captureMessage({
                      //   message: 'user self-tapes required questions',
                      //   data: { auditionSchedId },
                      // });
                      handleNext(SelftapesSteps.TERMS);
                    }}
                    questions={questions?.data || []}
                  />
                ) : activeStep === 3 ? (
                  <SelfTapesTerms
                    ndaRequired={ndaRequired}
                    nda={projectData?.attributes.nda_content}
                    auditionId={auditionSchedId}
                    handleNext={() => {
                      // captureMessage({
                      //   message: 'user self-tapes required terms',
                      //   data: { auditionSchedId },
                      // });
                      handleNext(SelftapesSteps.UPLOADS);
                    }}
                    handlePrev={() => history.goBack()}
                  />
                ) : (
                  <SelfTapesUpload
                    handleNext={() => {
                      // captureMessage({
                      //   message: 'user self-tapes submit self tapes',
                      //   data: { projectData, auditionSchedId, auditionData, self_tapes_revision_provided },
                      // });
                      handleNext(SelftapesSteps.COMPLETE);
                    }}
                    projectData={projectData}
                    auditionSchedID={auditionSchedId}
                    auditionData={auditionData}
                    self_tapes_revision_provided={self_tapes_revision_provided}
                  />
                )}
              </Grid>
            </Grid>
          )}
        </Grid>
      ) : (
        <></>
      )}
    </Grid>
  );
};

export default Form;
